import { rotateAnimation, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface IconWrapperProps {
  isLoading: boolean
}

export const IconWrapper = styled.span<IconWrapperProps>`
  margin-right: ${Spacing.S4};
  font-size: 40px;

  > svg {
    width: 40px;
    height: 40px;
    ${({ isLoading }) => isLoading && rotateAnimation()};
  }
`
